import * as React from 'react';
import { BodyPrimary } from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import { FormattedMessage, FormattedNumber } from '@liveauctioneers/hammer-ui-core/intl';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styled from 'styled-components';

export type PriceResultsProps = {
    count: number;
    creator?: string;
    isLoggedIn: boolean;
    seeAllUrl: string;
};

const PriceResults = ({ count: preFormattedCount, creator = '', seeAllUrl }: PriceResultsProps) => {
    if (preFormattedCount === 0) {
        return null;
    }

    return (
        <section>
            <SeeAllLink
                route
                to={seeAllUrl}
            >
                <LinkText>
                    {creator ? (
                        <FormattedMessage
                            id="see_auction_price_results_for"
                            values={{ token: creator }}
                        />
                    ) : (
                        <FormattedMessage
                            id="searchResults.seeAllPriceResults"
                            values={{
                                count: (
                                    <FormattedNumber
                                        key="price-results-count"
                                        maximumFractionDigits={0}
                                        minimumFractionDigits={0}
                                        value={preFormattedCount}
                                    />
                                ),
                            }}
                        />
                    )}
                </LinkText>
            </SeeAllLink>
        </section>
    );
};

export default React.memo<PriceResultsProps>(PriceResults, isEqual);

const SeeAllLink = styled(Link)`
    text-decoration: none;
`;

const LinkText = styled(BodyPrimary)`
    color: ${({ theme }) => theme.colors.blue100};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
        color: ${({ theme }) => theme.colors.blue200};
    }
`;
